import React, { useMemo, useEffect, useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { NavLink, useNavigate } from "react-router-dom";
import Papa from "papaparse";
import axios from "axios";
import { RotatingLines, Bars } from "react-loader-spinner";
import mime from "mime";
import GLOBALS from "../../utils/Globals";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Badge from "react-bootstrap/Badge";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileAction } from "../../redux/slices/users/usersSlice";
import { CheckIfBucketExists } from "../AWS/check-bucket-exist";
import DynamicForm from "./DynamicForm";
import { Tabs, Tab, Container, Row, Col, Image, Button, Modal, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import ImageCard from "./ImageCard";

export default function StyledDropzone(props) {
  const baseURLGetOpenAIQueuePDF =
    process.env.REACT_APP_ENV === "PROD"
      ? GLOBALS.PROD.baseURLGetOpenAIQueuePDF
      : GLOBALS.DEV.baseURLGetOpenAIQueuePDF;

  const baseURLGeneratePresignedURL =
    process.env.REACT_APP_ENV === "PROD"
      ? GLOBALS.PROD.baseURLGeneratePresignedURL
      : GLOBALS.DEV.baseURLGeneratePresignedURL;

  const baseURLSavePDFForOpenAI =
    process.env.REACT_APP_ENV == "PROD"
      ? GLOBALS.PROD.baseURLSavePDFForOpenAI
      : GLOBALS.DEV.baseURLSavePDFForOpenAI;

  const baseURLOpenAIGetDataPDF =
    process.env.REACT_APP_ENV == "PROD"
      ? GLOBALS.PROD.baseURLOpenAIGetDataPDF
      : GLOBALS.DEV.baseURLOpenAIGetDataPDF;

  const baseURLGetAIFieldLogic =
    process.env.REACT_APP_ENV === "PROD"
      ? GLOBALS.PROD.baseURLGetAIFieldLogic
      : GLOBALS.DEV.baseURLGetAIFieldLogic;

  const [email, setEmail] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState();
  const [files, setFiles] = useState([]);
  const [thumbnails, setThumbnails] = useState([]);
  const [openai, setOpenAi] = useState([]);
  const [dragError, setDragError] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [pendingFiles, setPendingFiles] = useState(null);

  const [bucketName, setBucketName] = useState(GLOBALS.AWS.S3_BUCKET_NAME);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    const handleFetchData = async () => {
      try {
        const result = await dispatch(getUserProfileAction());
        console.log("Data fetched successfully:", result.payload.user.email);
        setEmail(result.payload.user.email);
      } catch (error) {
        // Handle errors from the dispatch
        console.error("Error fetching data:", error);
      }
    };

    handleFetchData();
  }, [email]);

  const { error, loading, profile } = useSelector((state) => state?.users);

  // Fetch unique customer names from AI Field Logic collection
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axios.get(baseURLGetAIFieldLogic);
        const data = response.data?.data || [];
        const unique = [...new Set(data.map(item => item.customer).filter(Boolean))].sort();
        setCustomers(unique);
      } catch (err) {
        console.error('Error fetching customers:', err);
      }
    };
    fetchCustomers();
  }, [baseURLGetAIFieldLogic]);

  const onDrop = useCallback(async (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles && rejectedFiles.length > 0) {
      setTimeout(() => setDragError(null), 3000);
      return;
    }

    if (acceptedFiles?.length) {
      console.log('=== FILE DROP DEBUG ===');
      console.log('Number of files dropped:', acceptedFiles.length);
      console.log('Files:', acceptedFiles.map(f => f.name));

      // Check if more than one file is dropped
      if (acceptedFiles.length > 1) {
        const errorMessage = 'Please upload only one PDF file at a time';
        console.log('Multiple files detected, showing error:', errorMessage);
        setDragError(errorMessage);
        toast.error(errorMessage, {
          position: "bottom-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setTimeout(() => setDragError(null), 4000);
        return;
      }

      setDragError(null);
      // Store files and prompt for customer selection before uploading
      setPendingFiles(acceptedFiles);
      setSelectedCustomer('');
      setShowCustomerModal(true);
    }
  }, [email]);

  // Handles the actual upload after customer is confirmed
  const handleUploadWithCustomer = async () => {
    if (!selectedCustomer || !pendingFiles) return;

    setShowCustomerModal(false);
    const acceptedFiles = pendingFiles;
    setPendingFiles(null);

    setFiles(acceptedFiles);
    setIsLoading(true);

    const formData = new FormData();
    var thumbnails_array = [];
    acceptedFiles.forEach((file) => {
      formData.append("files", file);
      formData.append("owner", email);
      thumbnails_array.push(file.name + ".png");
    });
    formData.append("customer", selectedCustomer);

    try {
      console.log('=== UPLOADING PDF TO S3 SERVICE ===');
      console.log('URL:', baseURLSavePDFForOpenAI);
      console.log('Email:', email);
      console.log('Customer:', selectedCustomer);
      console.log('FormData files:', formData.getAll('files'));

      // upload files to API server
      const response = await axios.post(baseURLSavePDFForOpenAI, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log('PDF Upload Response:', response.data);
      console.log('Thumbnails array:', thumbnails_array);

      // get pre-signed urls
      console.log('=== GENERATING PRESIGNED URLS ===');
      const presignedUrls = [];
      for (const element of thumbnails_array) {
        const object_name = email + "/tmp/" + element;
        const bucket_name = GLOBALS.AWS.S3_BUCKET_NAME;

        console.log('Requesting presigned URL for:', object_name);
        console.log('Bucket:', bucket_name);

        const urlFormData = new FormData();
        urlFormData.append("object_name", object_name);
        urlFormData.append("bucket_name", bucket_name);
        urlFormData.append("email", email);

        try {
          const urlResponse = await axios.post(baseURLGeneratePresignedURL, urlFormData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          console.log('Presigned URL response:', urlResponse.data);
          presignedUrls.push(urlResponse.data.url);
        } catch (urlError) {
          console.error('Failed to get presigned URL for:', object_name);
          console.error('Error:', urlError);
          presignedUrls.push(null);
        }
      }
      console.log('All presigned URLs:', presignedUrls);

      setThumbnails(presignedUrls);
      setIsLoading(false);
    } catch (error) {
      console.error('=== PDF UPLOAD ERROR ===');
      console.error('Error details:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      console.error('Error message:', error.message);
      console.error('========================');

      setIsLoading(false);
      toast.error(`Error uploading file: ${error.message}`, {
        position: "bottom-right",
        autoClose: 5000
      });
    }
  };

  // Check for files passed from QuickDropzone
  useEffect(() => {
    if (window.quickDropFile && email) {
      try {
        const file = window.quickDropFile;
        console.log('Processing quick drop file:', file.name);

        // Process the file as if it was dropped
        onDrop([file]);

        // Clean up
        delete window.quickDropFile;
      } catch (error) {
        console.error('Error processing quick drop file:', error);
        delete window.quickDropFile;
      }
    }
  }, [email, onDrop]);

  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf']
    },
    multiple: false,
    onDropRejected: (rejectedFiles) => {
      const error = rejectedFiles[0]?.errors[0]?.message || 'Only PDF files are allowed';
      setDragError(error);
      toast.error('Please upload only PDF files', {
        position: "bottom-right",
        autoClose: 3000
      });
    }
  });

  const cancelClick = () => {
    navigate("/");
  };

  const handleSelect = (key) => {
    setActiveTab(key);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      {isLoading ? (
        <div className="flex flex-col items-center justify-center h-64">
          <Bars
            height="80"
            width="80"
            color="#2196f3"
            ariaLabel="bars-loading"
            visible={true}
          />
          <div className="mt-4 text-lg text-gray-600 font-medium">
            Uploading data...
          </div>
        </div>
      ) : (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Container className="bg-white rounded-xl shadow-sm p-6">
            {/* Only show dropzone if no files are uploaded */}
            {files.length === 0 && (
              <div
                {...getRootProps()}
                className={`
                  cursor-pointer
                  transition-all duration-300
                  border-2 border-dashed rounded-lg
                  p-8 mb-6
                  flex flex-col items-center justify-center
                  bg-gray-50 hover:bg-gray-100
                  ${isDragActive && !isDragReject ? 'border-blue-400 bg-blue-50' : ''}
                  ${isDragReject || dragError ? 'border-red-400 bg-red-50' : ''}
                  ${!isDragActive && !isDragReject && !dragError ? 'border-gray-300' : ''}
                `}
              >
                <input {...getInputProps()} />
                <div className="text-center">
                  {dragError ? (
                    <>
                      <svg
                        className="mx-auto h-12 w-12 text-red-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                      </svg>
                      <p className="mt-4 text-lg font-medium text-red-900">
                        Upload Error
                      </p>
                      <p className="mt-2 text-sm text-red-600">
                        {dragError}
                      </p>
                    </>
                  ) : (
                    <>
                      <svg
                        className={`mx-auto h-12 w-12 ${
                          isDragActive ? 'text-blue-400' : 'text-gray-400'
                        }`}
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 14v20c0 4.418 3.582 8 8 8h16c4.418 0 8-3.582 8-8V14M8 14c0-4.418 3.582-8 8-8h16c4.418 0 8 3.582 8 8M8 14h32"
                        />
                      </svg>
                      <p className="mt-4 text-lg font-medium text-gray-900">
                        {isDragActive ? (
                          "Drop your PDF file here..."
                        ) : (
                          "Drag and drop PDF file here, or click to select"
                        )}
                      </p>
                      <p className="mt-2 text-sm text-gray-500">
                        Only PDF files are supported
                      </p>
                    </>
                  )}
                </div>
              </div>
            )}

            {files.length > 0 && (
              <>
                <div className="flex justify-between items-center mb-6">
                  <Button
                    variant="outline-danger"
                    onClick={cancelClick}
                    className="hover:bg-red-50 transition-colors duration-200"
                  >
                    Cancel Import
                  </Button>
                  <div className="text-sm text-gray-600 text-right">
                    <span className="font-medium text-gray-800">{files[0]?.name}</span>
                    {selectedCustomer && (
                      <span className="ml-3 text-gray-500">
                        Customer: <span className="font-medium text-gray-700">{selectedCustomer}</span>
                      </span>
                    )}
                  </div>
                </div>

                <Tabs
                  activeKey={activeTab}
                  defaultActiveKey={0}
                  onSelect={handleSelect}
                  className="mt-3"
                >
                  {files.map((file, index) => (
                    <Tab
                      eventKey={index}
                      title={
                        <div className="flex items-center py-2">
                          <svg
                            className="w-4 h-4 mr-2 text-gray-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" />
                          </svg>
                          <span className="truncate max-w-xs">{file.name}</span>
                        </div>
                      }
                      key={index}
                    >
                      <div className="bg-white rounded-lg p-6 mt-4">
                        <div className="grid grid-cols-3 gap-4 mb-6">
                          <div className="text-sm">
                            <p className="font-medium text-gray-500">Name</p>
                            <p className="mt-1 text-gray-900">{file.name}</p>
                          </div>
                          <div className="text-sm">
                            <p className="font-medium text-gray-500">Size</p>
                            <p className="mt-1 text-gray-900">
                              {(file.size / 1024).toFixed(2)} KB
                            </p>
                          </div>
                          <div className="text-sm">
                            <p className="font-medium text-gray-500">Type</p>
                            <p className="mt-1 text-gray-900">{file.type}</p>
                          </div>
                        </div>

                        <div
                          className="grid grid-cols-2 gap-8"
                          style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '2rem',
                            alignItems: 'start'
                          }}
                        >
                          <div
                            className="bg-gray-50 rounded-lg p-4"
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-start',
                              justifyContent: 'flex-start'
                            }}
                          >
                            <ImageCard url={thumbnails[index]} />
                          </div>
                          <div className="bg-gray-50 rounded-lg p-4">
                            <DynamicForm
                              bucketName={bucketName}
                              objectName={file.name}
                              thumbnails={thumbnails[index]}
                              email={email}
                              customer={selectedCustomer}
                            />
                          </div>
                        </div>
                      </div>
                    </Tab>
                  ))}
                </Tabs>
              </>
            )}
          </Container>
        </div>
      )}

      {/* Customer Selection Modal */}
      <Modal show={showCustomerModal} onHide={() => setShowCustomerModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-gray-600 mb-3">Which customer is this PDF for?</p>
          <Form.Select
            value={selectedCustomer}
            onChange={(e) => setSelectedCustomer(e.target.value)}
          >
            <option value="">-- Select a customer --</option>
            {customers.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </Form.Select>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowCustomerModal(false)}>
            Cancel
          </Button>
          <Button
            variant="outline-primary"
            onClick={handleUploadWithCustomer}
            disabled={!selectedCustomer}
          >
            Upload PDF
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
